import {
	Backdrop,
	Box,
	Button,
	Checkbox,
	Chip,
	ClickAwayListener,
	Container,
	FormControl,
	IconButton,
	ListItemText,
	MenuItem,
	Select,
	TextField,
	Typography,
	useMediaQuery,
} from '@mui/material'
import AddPhotoAlternateRoundedIcon from '@mui/icons-material/AddPhotoAlternateRounded'
import AlarmIcon from '@mui/icons-material/Alarm'
import SellIcon from '@mui/icons-material/Sell'
import React, { useCallback, useEffect, useState } from 'react'
import { DOMAIN, api } from '../utils/api'
import { useDispatch, useSelector } from 'react-redux'
import { getFromStorage } from '../utils/storage'
import axios from 'axios'
import { handleError } from '../utils/error'
import { useNavigate, useParams } from 'react-router-dom'
import { currentUserActions } from '../redux/store'
import { borderFormat, mainGreen, mainGrey, mainRed } from '../utils/color'

export default function CreateGuestOrderForm(props) {
	const dispatch = useDispatch()
	const { storeId } = useParams()
	const navigate = useNavigate()
	const token = getFromStorage('current-user')?.accessToken
	const { currentUser } = useSelector((state) => state.currentUser)
	const [tags, setTags] = useState([])
	const [tagArray, setTagArray] = useState([])
	const [showBackdrop, setShowBackdrop] = useState(false)
	const mediaMd = useMediaQuery('(min-width:768px)')
	const [payment, setPayment] = useState(props.order.payment === 'transfer' ? true : false)
	const [paymentColor, setPaymentColor] = useState(props.order.payment === 'transfer' ? true : false)
	const [quickPurchase, setQuickPurchase] = useState(false)
	const [quickPurchaseColor, setQuickPurchaseColor] = useState(false)
	const [fileUpload, setFileUpload] = useState()
	const [photoAttach] = useState([])
	const [showTimer, setShowTimer] = useState(false)
	const [timerColor, setTimerColor] = useState(false)
	const [preview, setPreview] = useState()

	const tenDateAhead = []
	for (let i = 0; i < 10; i++) {
		const date = new Date()
		date.setDate(new Date().getDate() + i)
		tenDateAhead.push(
			date.toLocaleDateString(['en-GB'], {
				timeZone: 'Asia/Saigon',
				day: '2-digit',
				month: '2-digit',
				year: 'numeric',
			}),
		)
	}

	useEffect(() => {
		if (!fileUpload) {
			setPreview(undefined)
			return
		}

		const objectUrl = URL.createObjectURL(fileUpload)
		setPreview(objectUrl)

		return () => URL.revokeObjectURL(objectUrl)
	}, [fileUpload])

	const tagApiURL = useCallback(() => {
		if (currentUser.role === 'admin' || currentUser.role === 'director' || currentUser.role === 'assistant') {
			return `${DOMAIN}/storeManager/tags/${storeId}`
		} else {
			return `${DOMAIN}/storeManager/tags/${currentUser.store}`
		}
	}, [currentUser.role, currentUser.store, storeId])

	const getTags = useCallback(
		async function () {
			const url = tagApiURL()
			try {
				const response = await axios({
					url,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})

				setTags(response.data)
			} catch (error) {
				console.log(error.response.data.message)
			}
		},
		[token, tagApiURL],
	)

	useEffect(() => {
		if (currentUser.permission?.includes('updateTag')) {
			getTags()
		}
	}, [getTags, currentUser.permission])

	const handleChangeTag = (e) => {
		let { value, checked } = e.target
		if (checked === true) {
			tags.forEach((tag) => {
				if (tag.name === value) {
					setTagArray([...tagArray, { name: value, color: tag.color }])
				}
			})
		} else {
			setTagArray(tagArray?.filter((tag) => tag.name !== value))
		}
	}

	const [timer, setTimer] = useState({
		hours: '',
		minutes: '',
		second: new Date().getSeconds(),
		date: tenDateAhead[0],
	})

	const handleChangeTime = (e) => {
		const { name, value } = e.target
		const newValue = { ...timer, [name]: value }
		setTimer(newValue)
	}

	const [orderData, setOrderData] = useState({
		values: {
			quantity: props.order.quantity,
			detail: props.order.productInfo + ' ' + props.order.address + ' ' + props.order.name + ' ' + props.order.phone,
			totalPrice: props.order.bill.toLocaleString(),
		},
		errors: {
			quantity: '',
			detail: '',
			totalPrice: '',
		},
	})

	const handleCheckPayment = (e) => {
		if (!payment) {
			const confirmCheckPayment = window.confirm('Xác nhận chuyển khoản?')
			if (confirmCheckPayment) {
				setPayment(true)
				setPaymentColor(true)
			}
		} else {
			const confirmUncheckPayment = window.confirm('Bỏ chọn chuyển khoản?')
			if (confirmUncheckPayment) {
				setPayment(false)
				setPaymentColor(false)
			}
		}
	}

	const handleCheckPurchase = (e) => {
		if (!quickPurchase) {
			const confirmCheckQuickPurchase = window.confirm('Xác nhận mua nhanh?')
			if (confirmCheckQuickPurchase) {
				setQuickPurchase(true)
				setQuickPurchaseColor(true)
			}
		} else {
			const confirmUncheckQuickPurchase = window.confirm('Bỏ chọn mua nhanh?')
			if (confirmUncheckQuickPurchase) {
				setQuickPurchase(false)
				setQuickPurchaseColor(false)
			}
		}
	}

	const handleTimer = (e) => {
		setShowTimer(!showTimer)
		setTimerColor(!timerColor)
	}

	//------HANDLE CHANGE FORM VALUE------
	const handleChangeTotalPrice = (e) => {
		let { name, value } = e.target
		const removeChar = value.replace(/[^0-9.]/g, '')
		const removeDot = removeChar.replace(/\./g, '')
		const formatedNumber = removeDot.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
		let newValue = {
			...orderData.values,
			[name]: formatedNumber,
		}
		let newError = { ...orderData.errors }

		if (value.trim() === '') {
			newError[name] = '* Tiền không được để trống!'
		} else {
			if (Number(value) <= 0) {
				newError[name] = '* Tiền phải lớn hơn 0!'
			} else {
				newError[name] = ''
			}
		}
		setOrderData({ values: newValue, errors: newError })
	}

	const handleChange = (e) => {
		let { name, value } = e.target
		let newValue = { ...orderData.values, [name]: value }
		let newError = { ...orderData.errors }

		if (name === 'quantity') {
			if (value.trim() === '') {
				newError[name] = '* Khối lượng không được để trống!'
			} else {
				if (Number(value) <= 0) {
					newError[name] = '* Khối lượng phải lớn hơn 0!'
				} else {
					newError[name] = ''
				}
			}
		}

		if (name === 'detail') {
			if (value.trim() === '') {
				newError[name] = '* Thông tin không được để trống!'
			} else {
				if (value.length < 5) {
					newError[name] = '* Thông tin tối thiểu 5 ký tự!'
				} else {
					newError[name] = ''
				}
			}
		}

		setOrderData({ values: newValue, errors: newError })
	}

	//---SOCKET START POST CREATE ORDER------
	const handleSubmit = async (event) => {
		event.preventDefault()
		const quantity = orderData.values.quantity
		const detail = orderData.values.detail
		const totalPrice = Number(orderData.values.totalPrice.replace(/\D/g, ''))
		let paymentDetail
		if (payment === false) {
			paymentDetail = 'cash'
		} else {
			paymentDetail = 'transfer'
		}

		if (
			orderData.errors.quantity !== '' ||
			orderData.errors.totalPrice !== '' ||
			orderData.errors.detail !== '' ||
			quantity === '' ||
			totalPrice === '' ||
			detail === ''
		) {
			alert('Vui lòng điền đầy đủ thông tin hợp lệ!')
			return
		}

		if (!quickPurchase && currentUser.role === 'shipper') {
			alert('Bạn chỉ có thể tạo đơn hàng nhanh!')
		}

		const createOrderData = {
			quantity,
			totalPrice,
			detail,
			payment: paymentDetail,
			quickPurchase,
			photoAttach,
			store: currentUser.store || props.storeId,
			creator: currentUser,
			accessToken: token,
			app: false,
		}

		if (showTimer === true) {
			if (timer.date === '' || timer.hours === '' || timer.minutes === '') {
				alert('Điền đầy đủ thông tin hẹn giờ!')
				return
			} else {
				if (timer.hours < 0 || timer.hours > 23) {
					alert('Chọn giờ từ 0 đến 23')
					return
				}
				if (timer.minutes < 0 || timer.minutes > 59) {
					alert('Chọn phút từ 0 đến 59')
					return
				}
				const scheduleTime = new Date(
					`${timer.date.slice(3, 5)}/${timer.date.slice(
						0,
						2,
					)}/${timer.date.slice(6, 11)}, ${timer.hours}:${timer.minutes}`,
				).getTime()
				if (scheduleTime <= new Date().getTime()) {
					alert('Không thể hẹn giờ trong quá khứ')
					return
				}

				try {
					const formData = new FormData()
					formData.append('image', fileUpload)
					formData.append(
						'data',
						JSON.stringify({
							createOrderData: { ...createOrderData, tag: tagArray },
							timer: {
								...timer,
								date: timer.date.slice(0, 2),
								month: timer.date.slice(3, 5),
								year: Number(timer.date.slice(6, 11)),
							},
						}),
					)

					await axios({
						method: 'POST',
						headers: {
							Authorization: `Bearer ${token}`,
							'Content-Type': 'multipart/form-data',
						},
						url: api.POST_CREATE_TIMER_ORDER,
						data: formData,
						withCredentials: true,
					})
				} catch (error) {
					handleError(error)
					dispatch(currentUserActions.isLogout())
					navigate('/login')
				}
				await props.handleShowForm(false)
				await approveGuestOrder(props.order._id)
				alert(`Đã hẹn giờ tạo đơn hàng vào ${timer.hours}:${timer.minutes} ngày ${timer.date}`)
			}
		} else {
			await props.handleShowForm(false)

			try {
				const formData = new FormData()
				formData.append('image', fileUpload)
				formData.append('quantity', quantity)
				formData.append('totalPrice', totalPrice)
				formData.append('detail', detail)
				formData.append('payment', paymentDetail)
				formData.append('quickPurchase', quickPurchase)
				formData.append('store', currentUser.store || props.storeId)
				formData.append('creator', currentUser.id)
				formData.append('app', false)
				await axios({
					method: 'POST',
					headers: {
						Authorization: `Bearer ${token}`,
						'Content-Type': 'multipart/form-data',
					},
					url: api.POST_CREATE_ORDER,
					data: formData,
					withCredentials: true,
				})
			} catch (error) {
				handleError(error)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}

			await approveGuestOrder(props.order._id)

			setOrderData({
				values: {
					quantity: '',
					detail: '',
					totalPrice: '',
				},
				errors: {
					quantity: '',
					detail: '',
					totalPrice: '',
				},
			})
		}
	}

	const onFileChange = async (e) => {
		setFileUpload(e.target.files[0])
	}

	const approveGuestOrder = async (id) => {
		let url
		if (currentUser.permission.includes('manageAllGuestOrder')) {
			url = api.APPROVE_GUEST_ORDER_ADMIN
		} else {
			url = api.APPROVE_GUEST_ORDERS_STORE_MANAGER
		}
		try {
			await axios({
				url,
				method: 'PUT',
				headers: {
					Authorization: `Bearer ${token}`,
				},
				data: { id },
			})
			await props.getGuestOrders()
		} catch (err) {
			handleError(err)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	return (
		<ClickAwayListener
			onClickAway={() => {
				props.handleShowForm(false)
			}}>
			<Container
				onClick={(e) => {
					e.stopPropagation()
				}}
				onTouchEnd={(e) => {
					e.stopPropagation()
				}}
				sx={{
					background: mainGrey,
					borderTop: borderFormat,
					borderLeft: borderFormat,
					borderRight: borderFormat,
					borderRadius: '1rem 1rem 0 0',
					boxShadow: 'rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px',
				}}>
				<Box sx={{ textAlign: 'center' }}>
					<Chip sx={{ marginTop: '-20px', color: '#fff', background: mainGreen }} label={`ĐƠN ${props.index}`} />
				</Box>
				{fileUpload && (
					<img
						loading='lazy'
						style={{
							width: 30,
							height: 30,
							marginTop: '10px',
						}}
						src={preview}
						alt='preview'
					/>
				)}
				<Box component='form' onSubmit={handleSubmit} noValidate sx={{ pt: 2 }}>
					{orderData.errors.quantity === '' ? (
						<TextField
							type='number'
							value={orderData.values.quantity}
							sx={{
								background: '#fff',
								width: '40%',
								'& .MuiOutlinedInput-root': {
									'& fieldset': {
										borderRadius: '4px 0 0 4px',
									},
								},
							}}
							id='quantity'
							label='Khối lượng (kg)'
							name='quantity'
							autoComplete='quantity'
							onChange={handleChange}
						/>
					) : (
						<TextField
							type='number'
							value={orderData.values.quantity}
							sx={{
								background: '#fff',
								width: '40%',
								'& .MuiOutlinedInput-root': {
									'& fieldset': {
										borderRadius: '4px 0 0 4px',
									},
								},
							}}
							error
							id='quantity'
							label='Khối lượng (kg)'
							name='quantity'
							autoComplete='quantity'
							onChange={handleChange}
						/>
					)}

					{orderData.errors.totalPrice === '' ? (
						<TextField
							type='text'
							value={orderData.values.totalPrice}
							sx={{
								background: '#fff',
								width: '60%',
								'& .MuiOutlinedInput-root': {
									'& fieldset': {
										borderRadius: '0 4px 4px 0',
									},
								},
							}}
							id='totalPrice'
							label='Tiền (vnđ)'
							name='totalPrice'
							autoComplete='totalPrice'
							onChange={handleChangeTotalPrice}
						/>
					) : (
						<TextField
							type='text'
							value={orderData.values.totalPrice}
							sx={{
								background: '#fff',
								width: '60%',
								'& .MuiOutlinedInput-root': {
									'& fieldset': {
										borderRadius: '0 4px 4px 0',
									},
								},
							}}
							error
							id='totalPrice'
							label='Tiền (vnđ)'
							name='totalPrice'
							autoComplete='totalPrice'
							onChange={handleChangeTotalPrice}
						/>
					)}

					{orderData.errors.detail === '' ? (
						<TextField
							value={orderData.values.detail}
							sx={{ background: '#fff', mt: 1 }}
							type='text'
							fullWidth
							name='detail'
							label='Thông tin'
							id='outlined-multiline-flexible'
							multiline
							autoFocus
							autoComplete='detail'
							onChange={handleChange}
						/>
					) : (
						<TextField
							value={orderData.values.detail}
							sx={{ background: '#fff', mt: 1 }}
							type='text'
							error
							fullWidth
							name='detail'
							label='Thông tin'
							id='outlined-multiline-flexible'
							multiline
							autoFocus
							autoComplete='detail'
							onChange={handleChange}
						/>
					)}
					<Typography sx={{ color: '#ff0000' }}>{orderData.errors.quantity}</Typography>
					<Typography sx={{ color: '#ff0000' }}>{orderData.errors.totalPrice}</Typography>
					<Typography sx={{ color: '#ff0000' }}>{orderData.errors.detail}</Typography>
					<Box
						sx={{
							background: '#fff',
							padding: '0 10px',
							mt: 1,
							borderRadius: '4px',
							display: 'flex',
							justifyContent: mediaMd ? 'flex-start' : 'space-around',
							alignItems: 'center',
						}}>
						<Chip
							sx={{
								mr: mediaMd ? 3 : 0,
								background: paymentColor ? mainGreen : undefined,
								color: paymentColor ? '#fff' : '#000',
								'&:hover': {
									background: paymentColor ? mainGreen : undefined,
									color: paymentColor ? '#fff' : '#000',
								},
							}}
							onClick={handleCheckPayment}
							label='Chuyển khoản'
						/>
						<Chip
							sx={{
								mr: mediaMd ? 3 : 0,
								background: quickPurchaseColor ? mainGreen : undefined,
								color: quickPurchaseColor ? '#fff' : '#000',
								'&:hover': {
									background: quickPurchaseColor ? mainGreen : undefined,
									color: quickPurchaseColor ? '#fff' : '#000',
								},
							}}
							onClick={handleCheckPurchase}
							label='Mua nhanh'
						/>

						<IconButton
							sx={{
								padding: 0,
								position: 'relative',
								mr: mediaMd ? 4 : 0,
							}}
							onClick={handleTimer}>
							<AlarmIcon
								sx={{
									background: timerColor ? mainGreen : '#fff',
									padding: '4px',
									borderRadius: '50%',
									color: timerColor ? '#fff' : undefined,
								}}
							/>
						</IconButton>

						<IconButton sx={{ padding: '10px 0' }}>
							<label htmlFor='choose-photo' style={{ display: 'flex', cursor: 'pointer' }}>
								<AddPhotoAlternateRoundedIcon sx={{ color: 'rgba(0, 0, 0, 0.54)' }} />
							</label>
						</IconButton>
						<input accept='image/*' onChange={onFileChange} id='choose-photo' type='file' style={{ display: 'none' }} />
					</Box>
					{showTimer && (
						<Box
							sx={{
								background: '#fff',
								padding: '0 10px',
								mt: 1,
								pt: 1,
								pb: 1,
								borderRadius: '4px',
								display: 'flex',
								justifyContent: 'flex-start',
								alignItems: 'center',
							}}>
							<Box display='flex' justifyContent='flex-start'>
								<FormControl size='small' sx={{ maxWidth: 55 }}>
									<TextField
										placeholder='00'
										value={timer.hours}
										id='hoursSelect'
										name='hours'
										InputProps={{
											inputProps: {
												type: 'number',
												min: 0,
												max: 23,
											},
										}}
										onChange={handleChangeTime}
									/>
								</FormControl>
								<Typography sx={{ paddingLeft: '2px', paddingRight: '2px' }}>:</Typography>
								<FormControl size='small' sx={{ maxWidth: 55, mr: 2 }}>
									<TextField
										placeholder='00'
										value={timer.minutes}
										id='minutesSelect'
										name='minutes'
										type='number'
										InputProps={{
											inputProps: {
												type: 'number',
												min: 0,
												max: 59,
											},
										}}
										onChange={handleChangeTime}
									/>
								</FormControl>
							</Box>
							<FormControl sx={{ minWidth: 80, mr: 1 }} size='small'>
								<Select id='date-select' value={timer.date} name='date' onChange={handleChangeTime}>
									{tenDateAhead?.map((date, index) => {
										return (
											<MenuItem key={index} value={date}>
												{date.slice(0, 5)}
											</MenuItem>
										)
									})}
								</Select>
							</FormControl>
							<Button
								sx={{
									textTransform: 'none',
									minWidth: '50px',
									color: mainRed,
									borderColor: mainRed,
									'&:hover': {
										borderColor: mainRed,
									},
								}}
								size='small'
								variant='outlined'
								onClick={() => {
									setShowBackdrop(true)
								}}>
								<SellIcon sx={{ fontSize: '19px' }} />
							</Button>
							<Backdrop
								sx={{
									color: '#fff',
									zIndex: (theme) => theme.zIndex.drawer + 1,
									left: mediaMd ? 300 : 0,
								}}
								open={showBackdrop}
								onClick={() => {
									setShowBackdrop(false)
								}}>
								<Box>
									<Box
										sx={{
											background: '#fff',
											color: '#000',
											maxHeight: '400px',
											overflow: 'scroll',
											borderRadius: '5px',
										}}>
										<Typography
											sx={{
												textAlign: 'center',
												padding: '8px 10px',
												background: mainGreen,
												color: '#fff',
											}}>
											Tag đơn đặt trước
										</Typography>
										{tags.map((tag, index) => (
											<MenuItem
												onClick={(e) => {
													e.stopPropagation()
												}}
												key={index}>
												<Checkbox value={tag.name} onChange={handleChangeTag} />
												<ListItemText primary={tag.name} />
											</MenuItem>
										))}
									</Box>
								</Box>
							</Backdrop>
						</Box>
					)}

					<Box
						sx={{
							display: 'flex',
						}}>
						<Button
							fullWidth
							type='submit'
							variant='contained'
							sx={{
								mt: 2,
								mb: 2,
								background: mainGreen,
								'&:hover': { background: mainGreen },
							}}>
							Tạo đơn hàng
						</Button>
					</Box>
				</Box>
			</Container>
		</ClickAwayListener>
	)
}
